import { UserRole } from '@symfa-inc/providence-verizon-types';
import { canEdit } from '@core/utils/methods';

export const JURISDICTION_CAN_USER_EDIT = (): boolean =>
  canEdit([UserRole.Admin, UserRole.Permitting]);
